<ax-value-view-label [label]="label">
  <span>{{ value | formatDate }}</span>
</ax-value-view-label>
